// Toast context hook. Use pushToast() to queue a notification.
// Provider is in src/components/ui/Toast.tsx.

import { useContext } from 'react';
import { ToastContext } from '@/components/ui/Toast';

export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx) throw new Error('useToast must be used within ToastProvider');
    return ctx;
}
